const Cart = {
	addToCartAction: 'bk_woocommerce_ajax_add_to_cart',
	removeFromCartAction: 'bk_woocommerce_ajax_remove_from_cart',
	changeQuantityCartAction: 'bk_woocommerce_ajax_change_quantity',
	refreshCartQuantityAction: 'bk_woocommerce_ajax_get_cart_quantity',
	loading: false,
	init: () => {

		Cart.initListeners();
		// Cart.initCloseCartPopupOnOtherClick();
		// Cart.initCloseCartAlert();
	},



	initListeners: () => {
		// Cart.initStopCartPopupPropagation();
		// Cart.initCloseCartPopupOnCloseButtonClick();
		Cart.initQuantityChangeButtons();
		Cart.initAddToCartButton();
		Cart.initRemoveFromCartButton();
		Cart.initQuantityChange();
		Cart.initOnCartUpdate();
		// Cart.initCartQuantityOnChange();
	},

	initOnCartUpdate: () => {
		if(!document.body.matches('.woocommerce-cart')) return;

		document.addEventListener('wc_update_cart', (ev) => {
			console.log(ev);
		})
	},

	initQuantityChangeButtons: () => {
		const buttons = document.querySelectorAll(`[data-add-to-cart-quantity-direction]`);

		document.body.addEventListener('click', (ev) => {
			if(!ev.target.matches('[data-add-to-cart-quantity-direction]')){
				return;
			}
			const button = ev.target;

			ev.preventDefault();
			const direction = parseInt(button.getAttribute('data-add-to-cart-quantity-direction'));
			const input = button.closest('[data-add-to-cart]').querySelector('[data-add-to-cart-quantity]');
			if(!input) return;

			const currentValue = parseInt(input.value);
			let value = parseInt(input.value);
			const min = input.min;
			let max = input.max;
			if(max === '') max = Infinity;

			value += direction;
			if(value > max || value < min){
				value = currentValue;
			}
			input.value = value;
			input.dispatchEvent(new Event('change', { 'bubbles': true }));

			Cart.debounce(Cart.triggerUpdateCart, 500)();
		}, true)

		const input = document.querySelector(`[data-add-to-cart-quantity]`);
		if(!input){
		    return;
		}
		document.body.addEventListener('change', (ev) => {
			if(!ev.target.matches('[data-add-to-cart-quantity]')){
				return;
			}
			Cart.debounce(Cart.triggerUpdateCart, 500)();
		}, true)

	},

	triggerUpdateCart: () => {
		const updateButton = document.querySelector('button[name="update_cart"]');
		if(!updateButton) return;
		updateButton.click();
	},




	initCartQuantityOnChange: () => {

		document.body.addEventListener('change', (ev) => {
			if(ev.target.matches('td.product-quantity input.qty')){
				Cart.applyCartChanges();
			}
			if(ev.target.matches('.product-name__quantity input.qty')){
				const item = ev.target.closest('.cart_item');
				const input = item.querySelector(`td.product-quantity input.qty`);
				if(!input){
					return;
				}
				input.value = ev.target.value;
				Cart.applyCartChanges();
			}
		})

		// const inputs = document.querySelectorAll(`td.product-quantity input.qty`);
		// inputs.forEach((element) => {
		// 	element.addEventListener('change', Cart.debounce(Cart.applyCartChanges))
		// })
	},
	applyCartChanges: () => {
		const button = document.querySelector(`button[name='update_cart']`);
		if(!button){
			return;
		}
		button.click();
	},

	initCloseCartAlert: () => {
		const button = document.querySelector(`[data-cart-alert-button]`);
		const alert = document.querySelector(`[data-cart-alert]`);
		if(!button || !alert){
			return;
		}
		Cart.initStopCartAlertPropagation();

		const body = document.querySelector(`body`);
		if(!body){
			return;
		}
		body.addEventListener('click', () => {Cart.closeCartAlert()});
		button.addEventListener('click', (ev) => {ev.preventDefault(); Cart.closeCartAlert()});
	},
	closeCartAlert: () => {
		const alert = document.querySelector(`[data-cart-alert]`);
		if(!alert) return;
		alert.classList.remove('active');
	},

	initQuantityChange: () => {
		const inputs = document.querySelectorAll(`[data-quantity-change]`);
		inputs.forEach((input) => {
			input.addEventListener('change', Cart.debounce((ev) => {
				const cart_item_key = ev.target.getAttribute('data-quantity-change');
				const quantity = parseInt(ev.target.value);
				Cart.changeQuantity(cart_item_key, quantity, inputs);
			}, 500));
		})
	},

	timeout: null,
	debounce: (func, wait) => {
		let timeout;
		return (...args) => {
			const later = () => {
				clearTimeout(Cart.timeout);
				func(...args);
			};

			clearTimeout(Cart.timeout);
			Cart.timeout = setTimeout(later, wait);
		};
	},


	initRemoveFromCartButton: () => {
		const buttons = document.querySelectorAll('[data-remove-from-cart]:not(.remove-from-cart-initialized)');
		buttons.forEach((button) => {
			button.classList.add('remove-from-cart-initialized');
			button.addEventListener('click', (ev) => {
				ev.stopPropagation();
				ev.preventDefault();
				const cart_item_key = button.getAttribute('data-remove-from-cart');
				if(!cart_item_key) return;
				const showPopup = button.getAttribute('data-remove-from-cart-show-popup');
				Cart.removeFromCart(cart_item_key, showPopup);
			})
		});
	},

	initStopCartPopupPropagation: () => {
		const popup = document.querySelector('.add-to-cart-popup');
		if(!popup) return;
		popup.addEventListener('click', (ev) => {
			ev.stopPropagation();
		})
	},
	initStopCartAlertPropagation: () => {
		const alertContent = document.querySelector('[data-cart-alert-content]');
		if(!alertContent) return;
		alertContent.addEventListener('click', (ev) => {
			ev.stopPropagation();
		})
	},

	initCloseCartPopupOnCloseButtonClick: () => {
		const popup = document.querySelector('.add-to-cart-popup');
		const closeBtn = document.querySelector('.add-to-cart-popup__close');

		if(!popup || !closeBtn) return;

		closeBtn.addEventListener('click', (ev) => {
			popup.classList.remove('visible');
		});
	},

	initCloseCartPopupOnOtherClick: () => {
		document.querySelector('body').addEventListener('click', () => {
			Cart.setAddToCartPopupVisibility(false);
		});
	},

	initAddToCartButton: () => {
		const buttons = document.querySelectorAll('[data-add-to-cart]:not(.add-to-cart-initialized)');
		buttons.forEach((button) => {
			button.classList.add('add-to-cart-initialized');
			button.addEventListener('click', (ev) => {
				ev.stopPropagation();
				ev.preventDefault();
				const id_product = button.getAttribute('data-add-to-cart');
				if(!id_product) return;
				let quantity = 1;
				let id_variation = 0;
				let personalisation = '';
				if(button.getAttribute('data-add-to-cart-quantity')){
					quantity = parseInt(button.getAttribute('data-add-to-cart-quantity'));
				}
				if(button.getAttribute('data-add-to-cart-variation')){
					id_variation = parseInt(button.getAttribute('data-add-to-cart-variation'));
				}
				if(button.closest('form')){
					const form = button.closest('form');
					const quantityInput = form.querySelector('[name=quantity]');
					const variationInput = form.querySelector('[name=id_variation]');
					const personalisationInput = form.querySelector('[name=personalisation]');
					if(quantityInput) quantity = parseInt(quantityInput.value);
					if(variationInput) id_variation = parseInt(variationInput.value);

					if(personalisationInput){
						if(personalisationInput.value){
							personalisation = personalisationInput.value;
						}else{
							Cart.alert('Personalisation cannot be empty', true)
							return;
						}
					}
				}
				Cart.addToCart(id_product, quantity, id_variation, personalisation);
			})
		});
	},

	setLoading: (state) => {
		Cart.loading = state;
		document.querySelector(`body`).classList.toggle('woocommerce-refreshing', state);
	},

	getAjaxUrl: () => {
		if(typeof woocommerce_params !== 'undefined' && typeof woocommerce_params.ajax_url !== 'undefined'){
			return woocommerce_params.ajax_url;
		}
		return "/wp/wp-admin/admin-ajax.php";
	},

	changeQuantity: (cart_item_key, quantity, inputsToDisable = []) => {
		if(Cart.loading) return;
		Cart.setLoading(true);
		const data = new FormData();
		data.append('action', Cart.changeQuantityCartAction);
		data.append('cart_item_key', cart_item_key);
		data.append('quantity', quantity);

		inputsToDisable.forEach((input) => {
			input.setAttribute('disabled', true);
		});

		fetch(Cart.getAjaxUrl(), {
			method: 'POST',
			body: data
		}).then((json) => {
			return json.json();
		}).then((response) => {
			Cart.setLoading(false);
			if(response.success){
				Cart.applyFragments(response.fragments);
			}else{
				if(response.fragments){
					Cart.applyFragments(response.fragments);
				}
				Cart.alert(response.message, true);
			}
		}).catch((reason) => {
			Cart.setLoading(false);
			console.warn(reason);
			Cart.alert('An error occurred. Try again later.', true);
		})
	},

	addToCart: (id_product, quantity = 1, id_variation = 0, personalisation = '') => {
		if(Cart.loading) return;

		Cart.setLoading(true);
		const data = new FormData();
		data.append('action', Cart.addToCartAction);
		data.append('id_product', id_product);
		data.append('quantity', quantity);
		data.append('id_variation', id_variation);
		data.append('personalisation', personalisation);
		fetch(Cart.getAjaxUrl(), {
			method: 'POST',
			body: data
		}).then((json) => {
			return json.json();
		}).then((response) => {
			Cart.setLoading(false);
			// console.log(response);
			if(response.success){
				Cart.alert('Added to basket.')
				Cart.applyFragments(response.fragments);
				Cart.setAddToCartPopupVisibility(true);
				if(typeof response.count !== 'undefined'){
					const countWrapper = document.querySelectorAll(`[data-cart-count]`);
					countWrapper.forEach((element) => {
						element.innerText = response.count;
					});
				}
			}else{
				if(response.fragments){
					Cart.applyFragments(response.fragments);
				}
				Cart.alert(response.message, true);
			}
		}).catch((reason) => {
			Cart.setLoading(false);
			console.warn(reason);
			Cart.alert('An error occurred. Try again later.', true);
		})
	},

	alertTimeout: null,
	alert: (message, error = false) => {
		const alert = document.querySelector('[data-alert]');
		if(!alert) {
			window.alert(message);
			return;
		}
		alert.innerHTML = message;
		alert.classList.toggle('woocommerce-error', error);
		alert.classList.toggle('woocommerce-alert', !error);
		alert.classList.add('active');
		if(Cart.alertTimeout){
			clearTimeout(Cart.alertTimeout);
			Cart.alertTimeout = null;
		}
		Cart.alertTimeout = setTimeout(() => {
			alert.classList.remove('active');
			Cart.alertTimeout = null;
		}, 5000);
	},

	removeFromCart: (cart_item_key, refreshPopup = false) => {
		if(Cart.loading) return;

		Cart.setLoading(true);
		const data = new FormData();
		data.append('action', Cart.removeFromCartAction);
		data.append('cart_item_key', cart_item_key);

		fetch(Cart.getAjaxUrl(), {
			method: 'POST',
			body: data
		}).then((json) => {
			return json.json();
		}).then((response) => {
			Cart.setLoading(false);
			// console.log(response);
			if(response.success){
				Cart.applyFragments(response.fragments);
				if(refreshPopup){
					Cart.setAddToCartPopupVisibility(true);
				}
			}
		}).catch((reason) => {
			Cart.setLoading(false);
			console.warn(reason);
			Cart.alert('An error occurred. Try again later.', true);
		})
	},

	setAddToCartPopupVisibility: (state) => {
		const popup = document.querySelector('.add-to-cart-popup');
		if(!popup) return;
		setTimeout(() => {
			popup.classList.toggle('visible', state);
		}, 1);
	},

	applyFragments: (fragments) => {
		for(const selector in fragments){
			const el = document.querySelector(selector);
			if(!el) continue;
			el.outerHTML = fragments[selector];
		}
		Cart.initListeners();//to add listeners to new buttons
		return true;
	}

}

export default Cart;
